<app-part-selector [selectableParts]="data.parts" (partSelectedEvent)="selectedPart($event)"></app-part-selector>
